import { getIsMasterTablet } from "./browser/localStorage";

export const shouldEnableFeature = (toggle: string) => {
	const appMode = import.meta.env.VITE_ENV;
	const isMasterTablet = getIsMasterTablet();

	if (!isMasterTablet) {
		return false;
	}

	if (appMode === "production") {
		return true;
	} else if (appMode === "staging") {
		const hasStagingOverride = new URLSearchParams(window.location.search).get(toggle);
		return hasStagingOverride === "true";
	}

	return false;
};
